import React from 'react';
import { Dropdown } from 'semantic-ui-react';

let day = [];
let month = [];
let year = [];
for(var i= 1; i<32; i++){
    day.push({ key: i, text: '0'+i.toString(), value: i });
}
for (i = 1; i < 13; i++) {
    month.push({ key: i, text: '0'+i.toString(), value: i });
}
for (i = 2017; i > 1930; i--) {
    year.push({ key: i, text: i.toString(), value: i });
}
export function datePicker(id) {
    return (
        <td id={id} style ={{
            display:'flex',
        }}>
            <Dropdown
                id='day' placeholder='d' options={day}
                fluid
                selection
                onChange = {this.changeDate.bind(this)}
            />
            <Dropdown
                id='month' placeholder='mm' options={month}
                fluid
                selection
                onChange={this.changeDate.bind(this)}
            />
            <Dropdown
                id='year' placeholder='yyyy' options={year}
                fluid
                selection
                onChange={this.changeDate.bind(this)}
            />
        </td>
   
    );
}



// WEBPACK FOOTER //
// ./src/components/PanelPages/datePicker.jsx